module.exports = __webpack_public_path__ + "img/icon-nav-finance-white.ca1dff8.svg";